module.exports = __webpack_public_path__ + "img/wooddust_icon.9f0ab5b8.svg";